import type { FC, InputHTMLAttributes } from "react";

import { Text } from "../Text";

interface FormInputProps extends Omit<
  InputHTMLAttributes<HTMLInputElement>,
  "size"
> {
  label?: string;
  error?: string;
  helperText?: string;
  size?: "sm" | "md";
}

const sizeClasses = {
  md: "px-3 py-2 text-xs",
  sm: "px-2.5 py-1.5 text-[10px]",
} as const;

/**
 * Shared form input component with consistent styling
 * Matches TaskActivityFilters reference tokens
 */
export const FormInput: FC<FormInputProps> = ({
  label,
  error,
  helperText,
  size = "md",
  className = "",
  ...inputProps
}) => (
  <div>
    {label && (
      <Text
        variant="caption"
        as="label"
        className="mb-1 block font-mono text-[10px] font-bold uppercase tracking-widest text-slate-500 dark:text-slate-400"
      >
        {label}
      </Text>
    )}
    <input
      {...inputProps}
      className={`w-full rounded-none border border-slate-300 bg-white font-mono text-slate-900 transition-colors focus:border-emerald-500 focus:outline-none focus:ring-1 focus:ring-emerald-500 dark:border-slate-700 dark:bg-arti-background dark:text-slate-100 ${sizeClasses[size]} ${className}`}
    />
    {helperText && !error && (
      <Text
        as="p"
        className="mt-1 font-mono text-[10px] text-slate-500 dark:text-slate-400"
      >
        {helperText}
      </Text>
    )}
    {error && (
      <p className="mt-1 font-mono text-[10px] font-bold text-rose-600 dark:text-rose-400">
        {error}
      </p>
    )}
  </div>
);
